import { useLanguage } from '../context/LanguageContext';
import { translations } from '../i18n/translations';

const useTranslation = () => {
  const { lang, setLang } = useLanguage();

  const t = (key) => {
    const parts = key.split('.');
    let node = translations[lang];
    for (const p of parts) {
      if (node == null) return key;
      node = node[p];
    }
    return (node != null && node !== '') ? node : key;
  };

  return { t, lang, setLang };
};

export default useTranslation;
